const config = {
  development: {
    SERVER: 'http://localhost:8080/api',
  },
  production: {
    SERVER: 'https://dagrades.onrender.com/api',
  },
};

export default config;